<div class="adv-filters">
  <div class="adv-filters__rows">
    <div class="adv-filters__row" *ngFor="let row of rows; let i = index; trackBy: trackByIndex">
      <!-- Field -->
      <mat-form-field appearance="outline" class="adv-filters__field">
        <mat-label>{{ 'AdvFilterField' | translate }}</mat-label>
        <mat-select [(ngModel)]="row.field">
          <mat-option *ngFor="let col of availableColumns" [value]="col.id">
            {{ col.name | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Operator -->
      <mat-form-field appearance="outline" class="adv-filters__operator">
        <mat-label>{{ 'AdvFilterType' | translate }}</mat-label>
        <mat-select [(ngModel)]="row.operator">
          <mat-option *ngFor="let op of textOperators" [value]="op.value">
            {{ op.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Value -->
      <mat-form-field
        appearance="outline"
        class="adv-filters__value"
        *ngIf="!isEmptyOperator(row.operator)"
      >
        <mat-label>{{ 'AdvFilterValue' | translate }}</mat-label>
        <input matInput [(ngModel)]="row.value" />
      </mat-form-field>

      <!-- Remove -->
      <button mat-icon-button class="adv-filters__remove" (click)="removeRow(i)" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <button mat-stroked-button class="adv-filters__add-row" (click)="addRow()" type="button">
      <mat-icon>add</mat-icon>
      {{ 'AdvFilterAddCondition' | translate }}
    </button>
  </div>

  <!-- Date filter -->
  <div class="adv-filters__date-section">
    <mat-checkbox color="primary" [(ngModel)]="enableDateFilter">
      {{ 'AdvFilterCreatedAt' | translate }}
    </mat-checkbox>

    <div class="adv-filters__date-controls" *ngIf="enableDateFilter">
      <mat-form-field appearance="outline" class="adv-filters__operator">
        <mat-label>{{ 'AdvFilterType' | translate }}</mat-label>
        <mat-select [(ngModel)]="dateOperator">
          <mat-option *ngFor="let op of dateOperators" [value]="op.value">
            {{ op.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="adv-filters__date"
        *ngIf="dateOperator === 'gt' || dateOperator === 'bt'"
      >
        <mat-label>{{ 'AdvFilterFrom' | translate }}</mat-label>
        <input matInput [(ngModel)]="dateFrom" [matDatepicker]="pickerFrom" />
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="adv-filters__date"
        *ngIf="dateOperator === 'lt' || dateOperator === 'bt'"
      >
        <mat-label>{{ 'AdvFilterTo' | translate }}</mat-label>
        <input matInput [(ngModel)]="dateTo" [matDatepicker]="pickerTo" />
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="adv-filters__actions">
    <button mat-stroked-button (click)="clear()" type="button">
      {{ 'AdvFilterClear' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="apply()" type="button">
      {{ 'AdvFilterApply' | translate }}
    </button>
  </div>
</div>
